export const validateForm = async (to, from, next, validate, emit) => {
  if (to.meta.order >= from.meta.order) {
    const { valid } = await validate();
    if (valid) {
      emit('transit', 'next-slide');
      next();
    } else {
      next(false);
    }
    return;
  } else {
    triggerBackSlide(to, from, next, emit);
    return;
  }
};

export const triggerBackSlide = (to, from, next, emit) => {
  if (to.meta.order < from.meta.order) {
    emit('transit', 'back-slide');
    next();
  }
};